import React from 'react';

import { LinkProps } from '../../blocks/editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';

export interface EditorialPageFullWidthWrapperProps extends LinkProps {
  topBlock?: boolean | null;
  banner?: boolean;
  isImage?: boolean;
  cardType?: string;
  body?: any;
}

const EditorialPageFullWidthWrapper = ({
  children,
  topBlock,
  cardType,
  banner,
  isImage,
  body,
}: React.PropsWithChildren & EditorialPageFullWidthWrapperProps) => {
  const bannerCss =
    'px-6  sm:px-0 sm:bg-transparent lg:pt-0 ' +
    (!topBlock ? 'sm:pt-0 rounded-card-mobile ' : ' ') +
    ((topBlock && !isImage) || !isImage ? 'pt-0 sm:pt-6 ' : 'pt-6 ') +
    (!body ? 'pb-6 ' : ' ');

  return (
    <div
      className={
        'flex h-auto w-full flex-col items-start justify-start bg-background-primary-light sm:gap-4 ' +
        (banner ? bannerCss : ' ') +
        ((!isImage && !topBlock) ||
        (!isImage && cardType === 'Column item' && !topBlock)
          ? 'rounded-card-mobile '
          : 'rounded-b-card-mobile ') +
        (cardType === 'Default'
          ? 'flex-1 self-stretch sm:bg-transparent  '
          : ' ') +
        (cardType === 'Column item' ? 'sm:rounded-card-mobile ' : ' ') +
        (cardType === 'Carousel item'
          ? 'h-full rounded-b-card-mobile sm:rounded-card-mobile '
          : ' ')
      }
    >
      {children}
    </div>
  );
};

export default EditorialPageFullWidthWrapper;
